import axios from 'axios';
const dejaAPI = process.env.REACT_APP_DEJA_API;
const cloudAPI = process.env.REACT_APP_SERVER_API;
const adminAPI = process.env.REACT_APP_NODE_API;

export const apiPrefix = {
  dejaAPI,
  cloudAPI,
  adminAPI
}

export const localStore = {
    setStore: function(id, data) {
      return localStorage.setItem(id, JSON.stringify(data));
    },
    getStore: function(id, data) {
      return JSON.parse(localStorage.getItem(id));
    },
    clear: function() {
      localStorage.clear();
    }
}

export const apiHelper = (config = {}) => {
    const defaultOptions = {
      timeout: 10000,
      baseURL: cloudAPI,
    }
    const options = {
      ...defaultOptions,
      ...config,
    };
    return axios.request(options)
        .then(function (response) {
            // console.log(response.data);
            // console.log(response.status);
            // console.log(response.statusText);
            // console.log(response.headers);
            // console.log(response.config);
            return {
                ...response.data,
            }
        })
        .catch(error => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return {
                    isError: true,
                    status: error.response.status,
                    data: error.response.data
                }
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
                console.log('no response from server');
                return {
                    isError: true
                }
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                return {
                    isError: true
                }
              }
        })
}


// WEBPACK FOOTER //
// ./src/common/utils.js